export default {
  /* ==========================
      ABOUT SUPPLIER
  ========================== */

  for: "FOR",
  suppliers: "SUPPLIERS",

  // Heading
  grow_business: "Grow Your",
  with: "Supply Business",

  supplier_from: "with",
  supplier_highlight: "Trusted Restaurants",

  supplier_desc:
    "MAHAL is a B2B marketplace built to help suppliers connect directly with restaurants, receive consistent orders, and scale their business with confidence.",

  supplier_text:
    "From local producers to large distributors, MAHAL empowers suppliers with access to verified restaurants, transparent pricing, and long-term business partnerships — all in one unified platform.",

  // Feature Cards
  highlight1: "Direct Restaurant Access",
  highlight2: "Bulk & Recurring Orders",
  highlight3: "Timely & Secure Payments",
  highlight4: "Business Growth Support",

  // CTA
  become_supplier: "Become a Supplier",
  talk_team: "Talk to Our Team",
};